/*
reaction.js
This module handles reaction pill clicks (e.g., fire, blueheart, puke) and updates reaction counts.
*/

export function initReactionHandlers(config) {
    // Attach a document-level event listener for reaction pill clicks.
    document.addEventListener('click', async (event) => {
      const pill = event.target.closest('.reaction-pill');
      if (pill) {
        event.preventDefault();
        await handleReactionClick(pill, config);
      }
    });
  }
  
  async function handleReactionClick(pill, config) {
    const ratingId = pill.getAttribute('data-rating-id');
    const emoji = pill.getAttribute('data-emoji');
    let symbol = '';
    switch (emoji) {
      case 'fire':
        symbol = '🔥';
        break;
      case 'blueheart':
        symbol = '💙';
        break;
      case 'puke':
        symbol = '🤮';
        break;
      default:
        symbol = '❤️';
    }
  
    createReactionAnimation(pill, symbol);
  
    try {
      const resp = await fetch(`/feed/${ratingId}/react`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': config.csrfToken,
        },
        body: JSON.stringify({ emoji }),
      });
      if (resp.ok) {
        const data = await resp.json();
        if (data.success === true && typeof data.users_count === 'number') {
          const countSpan = document.getElementById(`${emoji}-count-${ratingId}`);
          if (countSpan) {
            countSpan.textContent = data.users_count;
          }
        }
      }
    } catch (error) {
      console.error('Reaction error:', error);
    }
  }
  
  function createReactionAnimation(emojiEl, symbol) {
    const container = document.createElement('div');
    container.classList.add('reaction-emoji-container');
    const btnRect = emojiEl.getBoundingClientRect();
    container.style.left = (btnRect.left + window.scrollX + btnRect.width / 2) + 'px';
    container.style.top = (btnRect.top + window.scrollY - 30) + 'px';
    document.body.appendChild(container);
  
    for (let i = 0; i < 6; i++) {
      const span = document.createElement('span');
      span.classList.add('reaction-emoji');
      span.textContent = symbol;
      const offsetX = (Math.random() - 0.5) * 40;
      span.style.left = offsetX + 'px';
      const delay = Math.random() * 0.4;
      span.style.animationDelay = `${delay}s`;
      container.appendChild(span);
    }
  
    setTimeout(() => container.remove(), 1500);
  }
  